import React from 'react';
import { portfolio } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

const Portfolio = () => {
  return (
    <section id="work" className="bg-black py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16">
          <div>
            <p className="text-white/40 text-sm uppercase tracking-widest mb-4">
              Our Work
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              We build products that<br />users love and scale fast
            </h2>
          </div>
          <a
            href="#contact"
            className="mt-6 md:mt-0 text-white/60 hover:text-white transition-colors flex items-center gap-2 group"
          >
            View all work
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </a>
        </div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {portfolio.map((project, index) => (
            <div
              key={project.id}
              className={`group relative rounded-2xl overflow-hidden bg-neutral-900 hover:scale-[1.02] transition-all duration-500 ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              {/* Project Image */}
              <div className={`relative ${index === 0 ? 'aspect-[4/3]' : 'aspect-[4/3]'}`}>
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              </div>

              {/* Project Info */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={project.logo}
                    alt={project.name}
                    className="h-6 object-contain filter brightness-0 invert"
                  />
                </div>
                <h3 className="text-white font-semibold text-xl mb-1">
                  {project.name}
                </h3>
                <p className="text-white/50 text-sm">
                  {project.category} / {project.platforms}
                </p>
              </div>

              {/* Hover Arrow */}
              <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <ArrowUpRight className="w-5 h-5 text-white" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;